import { ToastrService } from 'ngx-toastr';
import { of, pipe } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { State } from '../services/work.state';

export const infoMessage = (toastr: ToastrService) =>
  pipe(
    switchMap(([state, currentState]: [Partial<State>, State]) => {
      if (state.system?.info) {
        const toastIds: number[] = [];
        const toast = toastr.info(state.system?.info, 'Script Info', {
          disableTimeOut: true,
          closeButton: true,
          enableHtml: true,
        });
        toastIds.push(toast.toastId);
        /*
        if (state.system.navToQ && state.system.navToQ != '?') {
          const badScriptToast = toastr.error(
            'Script attempted to show an info message and navigate at the same time, which is not allowed. Please contact support.',
            'Script Error',
            {
              disableTimeOut: true,
              closeButton: true,
              enableHtml: true,
            }
          );
          toastIds.push(badScriptToast.toastId);
        }
        */
        const newState = {
          ...state,
          ...{
            system: {
              ...state.system,
              ...{
                info: undefined,
                //navToQ: undefined,
                activeToasts: [
                  ...(state.system?.activeToasts || []),
                  ...toastIds,
                ],
              },
            },
          },
        };
        return of([newState, currentState] as [Partial<State>, State]);
      }

      return of([state, currentState] as [Partial<State>, State]);
    })
  );
